import { FC } from "react";

const ProductCheckbox: FC<{
  register: Function;
  name: string;
}> = ({ register, name }) => {
  return (
    <div>
      <input
        id={name}
        type="checkbox"
        className="w-[15px] h-[15px] cursor-pointer accent-[#32a3ce]"
        {...register(name)}
      />
    </div>
  );
};

export default ProductCheckbox;
